import ElementConfig from '../classes/definitions/formItem/ElementConfig';
import FormItem from '../classes/definitions/formItem/FormItem';
var staticPageSchema = {
    bg_name: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
            type: 'text',
        }),
        elementType: 'input',
        label: 'Име на български *',
        value: '',
        validation: {
            required: true
        },
        valid: false,
        touched: false,
        errorMsg: 'Моля, въвдете валидно име',
    }),
    en_name: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
            type: 'text',
        }),
        elementType: 'input',
        label: 'Име на английски *',
        value: '',
        validation: {
            required: true
        },
        valid: false,
        touched: false,
        errorMsg: 'Моля, въвдете валидно име',
    }),
    slug: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
            type: 'text',
        }),
        elementType: 'input',
        label: 'Slug *',
        value: '',
        validation: {
            required: true
        },
        valid: false,
        touched: false,
        errorMsg: 'Моля, въвдете валиден slug',
    }),
    position: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
            type: 'number',
        }),
        elementType: 'input',
        label: 'Позиция',
        value: 50,
        validation: {
            required: false
        },
        valid: true,
        touched: false,
        errorMsg: 'Моля, въведете валидна позиция',
    }),
    // bg_description: new FormItem({
    //     elementConfig: new ElementConfig({
    //         className: 'editor',
    //     }),
    //     elementType: 'editor',
    //     label: 'Описание на български *',
    //     value: null,
    //     validation: {
    //         required: true
    //     },
    //     valid: false,
    //     touched: false,
    //     errorMsg: 'Моля, въвдете валидно описание на български',
    // }),
    bg_description_json: new FormItem({
        elementConfig: new ElementConfig({
            className: 'btn btn-primary',
        }),
        elementType: 'buttonModal',
        label: 'Описание на български *',
        value: null,
        validation: {
            required: true
        },
        valid: false,
        touched: false,
        errorMsg: 'Моля, въвдете валидно описание на български',
    }),
    // bg_bottom_description: new FormItem({
    //     elementConfig: new ElementConfig({
    //         className: 'editor',
    //     }),
    //     elementType: 'editor',
    //     label: 'Описание под продуктите на български',
    //     value: null,
    //     validation: {
    //         required: false
    //     },
    //     valid: true,
    //     touched: false,
    //     errorMsg: 'Моля, въвдете валидно описание на български',
    // }),
    bg_bottom_description_json: new FormItem({
        elementConfig: new ElementConfig({
            className: 'btn btn-primary',
        }),
        elementType: 'buttonModal',
        label: 'Описание под продуктите на български',
        value: null,
        validation: {
            required: false
        },
        valid: true,
        touched: false,
        errorMsg: 'Моля, въвдете валидно описание на български',
    }),
    // en_description: new FormItem({
    //     elementConfig: new ElementConfig({
    //         className: 'editor',
    //     }),
    //     elementType: 'editor',
    //     label: 'Описание на английски *',
    //     value: null,
    //     validation: {
    //         required: true
    //     },
    //     valid: false,
    //     touched: false,
    //     errorMsg: 'Моля, въвдете валидно описание на английски',
    // }),
    en_description_json: new FormItem({
        elementConfig: new ElementConfig({
            className: 'btn btn-primary',
        }),
        elementType: 'buttonModal',
        label: 'Описание на английски *',
        value: null,
        validation: {
            required: true
        },
        valid: false,
        touched: false,
        errorMsg: 'Моля, въвдете валидно описание на английски',
    }),
    // en_bottom_description: new FormItem({
    //     elementConfig: new ElementConfig({
    //         className: 'editor',
    //     }),
    //     elementType: 'editor',
    //     label: 'Описание под продуктите на английски',
    //     value: null,
    //     validation: {
    //         required: false
    //     },
    //     valid: true,
    //     touched: false,
    //     errorMsg: 'Моля, въвдете валидно описание на английски',
    // }),
    en_bottom_description_json: new FormItem({
        elementConfig: new ElementConfig({
            className: 'btn btn-primary',
        }),
        elementType: 'buttonModal',
        label: 'Описание под продуктите на английски',
        value: null,
        validation: {
            required: false
        },
        valid: true,
        touched: false,
        errorMsg: 'Моля, въвдете валидно описание на английски',
    }),
    categories: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
        }),
        elementType: 'autocomplete',
        label: 'Категории',
        value: null,
        validation: {
            required: false,
        },
        valid: true,
        touched: false,
        errorMsg: 'Моля, въвдете валиден Option Type',
    }),
    brand_category: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
        }),
        elementType: 'autocomplete',
        label: 'Маркови категории',
        value: null,
        validation: {
            required: false,
        },
        valid: true,
        touched: false,
        errorMsg: 'Моля, въвдете валиден Option Type',
    }),
    display: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
            options: [],
        }),
        elementType: 'dropdown',
        label: 'Позициониране* ',
        value: '',
        validation: {
            required: false,
        },
        valid: false,
        touched: false,
        errorMsg: 'Моля, въведете валиден статус',
    }),
    meta_title: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
        }),
        elementType: 'input',
        label: 'Meta Заглавие',
        value: '',
        validation: {
            required: false
        },
        valid: true,
        touched: true,
        errorMsg: 'Моля, въведете валидно заглавие',
    }),
    meta_description: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
        }),
        elementType: 'textarea',
        label: 'Meta Описание',
        value: '',
        validation: {
            required: false
        },
        valid: true,
        touched: true,
        errorMsg: 'Моля, въведете валидно описание',
    }),
};
export default staticPageSchema;



//////////////////
// WEBPACK FOOTER
// ./src/schemas/staticPageSchema.ts
// module id = 542
// module chunks = 0